import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { EncabezadoPagina } from '@xiltrion/ui/bloques/encabezado-pagina';
import { EstadoCargando } from '@xiltrion/ui/bloques/estados';
import { Tabs, TabsList, TabsTrigger } from '@xiltrion/ui/tabs';
import { apiGet } from '@/api/client';
import { useTeams } from '@/api/hooks';
import type { View } from '@/api/types';
import { useSession, useTerms } from '@/app/session';
import { ViewHost } from './ViewHost';

/**
 * «Mis tareas» (MeisterTask Agenda + Asana My Tasks): las tareas asignadas a mí, de todos los proyectos, con vistas
 * personales. Quien integra o dirige un equipo ve además lo que llegó a su equipo sin repartir (`?de=equipo`).
 */
export function MyTasks() {
  const qc = useQueryClient();
  const { me } = useSession();
  const { lower } = useTerms();
  const { mine } = useTeams(me?.userId);
  const [params, setParams] = useSearchParams();
  const team = params.get('de') === 'equipo' && mine.size > 0;
  const { data, isLoading } = useQuery({ queryKey: ['views', 'my-tasks'], queryFn: () => apiGet<{ views: View[]; lastViewId: string | null }>('/views/my-tasks') });
  if (isLoading || !data) return <div className="p-6"><EstadoCargando /></div>;
  const pick = (v: string) => setParams((p) => { const n = new URLSearchParams(p); if (v === 'team') n.set('de', 'equipo'); else n.delete('de'); return n; }, { replace: true });
  return (
    <ViewHost scope="my_tasks" project={null} views={data.views} lastViewId={data.lastViewId} taskQuery={team ? { teamInbox: true } : { mine: true }} canManage invalidateViews={() => void qc.invalidateQueries({ queryKey: ['views', 'my-tasks'] })}
      header={
        <div className="px-4 pt-4">
          <EncabezadoPagina titulo="Mis tareas" descripcion={team ? `Lo que llegó a tu ${lower('team')} y nadie tiene todavía: repártelo o tómalo.` : 'Lo que tienes asignado en todos los proyectos.'}
            acciones={mine.size > 0 && (
              <Tabs value={team ? 'team' : 'mine'} onValueChange={pick}>
                <TabsList><TabsTrigger value="mine">Asignadas a mí</TabsTrigger><TabsTrigger value="team">De mi {lower('team')}</TabsTrigger></TabsList>
              </Tabs>
            )} />
        </div>
      } />
  );
}
